// City Based Application Stage vocabulary, pinned as a static tree.
//
// PermitApplicationForm used to walk this cascade one level at a time against
// api/permit_application/get?options=1, so every click on a select waited on a
// request. The vocabulary changes rarely, so the whole tree lives here for now.
// Terms read City -> Permit Type -> Stage (a few branches go deeper); only a
// LEAF is a valid value for field_city_based_application_sta.
//
// `id` is the Drupal tid and is what gets written. Re-export from the backend
// when terms are added there.
export const CITY_APPLICATION_STAGES = [
  {
    name: "Airdrie",
    id: 23537,
    children: [
      {
        name: "Building Permit",
        id: 23538,
        children: [
          { name: "Application Submitted", id: 23559 },
          { name: "Issued", id: 23539 },
        ],
      },
    ],
  },
  {
    name: "Revelstoke",
    id: 25857,
    children: [
      {
        name: "Development Permit",
        id: 25858,
        children: [
          { name: "Application Submitted", id: 25859 },
          { name: "Issued Date", id: 25860 },
        ],
      },
      {
        name: "Building Permit",
        id: 25861,
        children: [
          { name: "Application Submitted", id: 25862 },
          { name: "Issued Date", id: 25863 },
        ],
      },
    ],
  },
  {
    name: "Fernie",
    id: 25850,
    children: [
      {
        name: "Development Permit",
        id: 25851,
        children: [
          { name: "Application Submitted", id: 25852 },
          { name: "Issued Date", id: 25853 },
        ],
      },
      {
        name: "Building Permit",
        id: 25854,
        children: [
          { name: "Issued Date", id: 25856 },
          { name: "Application Submitted", id: 25855 },
        ],
      },
    ],
  },
  {
    name: "Peachland",
    id: 25843,
    children: [
      {
        name: "Development Permit",
        id: 25844,
        children: [
          { name: "Application Submitted", id: 25845 },
          { name: "Issued", id: 25846 },
        ],
      },
      {
        name: "Building Permit (GS)",
        id: 25847,
        children: [
          { name: "Issued Date", id: 25849 },
          { name: "Application Submitted", id: 25848 },
        ],
      },
    ],
  },
  {
    name: "UBC",
    id: 25827,
    children: [
      {
        name: "Development Permit",
        id: 25828,
        children: [
          { name: "Application Date", id: 25829 },
          { name: "Issued Date", id: 25830 },
        ],
      },
      {
        name: "Building Permit",
        id: 25831,
        children: [
          { name: "Application Date", id: 25832 },
          { name: "Issued Date", id: 25833 },
        ],
      },
    ],
  },
  {
    name: "Kamloops",
    id: 25810,
    children: [
      { name: "Development Permit", id: 25813, children: [{ name: "Issued", id: 25814 }] },
      { name: "Building Permit", id: 25811, children: [{ name: "Issued", id: 25812 }] },
    ],
  },
  {
    name: "Parksville",
    id: 25801,
    children: [
      { name: "Building Permit (YS)", id: 25802, children: [{ name: "Issued", id: 25803 }] },
      { name: "Development Permit", id: 25804, children: [{ name: "Issued", id: 25805 }] },
    ],
  },
  {
    name: "Prince George",
    id: 25793,
    children: [
      { name: "Building Permit", id: 25794, children: [{ name: "Issued Date", id: 25795 }] },
      { name: "Development Permit", id: 25796, children: [{ name: "Issued Date", id: 25797 }] },
    ],
  },
  {
    name: "University Endowment Land",
    id: 25771,
    children: [
      {
        name: "Development Permit",
        id: 25772,
        children: [
          { name: "Application Date", id: 25773 },
          { name: "Issued Date", id: 25774 },
        ],
      },
      {
        name: "Building Permit",
        id: 25775,
        children: [
          { name: "Application Date", id: 25776 },
          { name: "Issued Date", id: 25777 },
        ],
      },
    ],
  },
  {
    name: "Summerland",
    id: 24097,
    children: [
      {
        name: "Building Permit",
        id: 24098,
        children: [
          { name: "Application Submitted", id: 24099 },
          { name: "Issued", id: 24100 },
        ],
      },
      {
        name: "Development Permit",
        id: 25798,
        children: [
          { name: "Application Date", id: 25799 },
          { name: "Issued", id: 25800 },
        ],
      },
    ],
  },
  {
    name: "Markham",
    id: 24093,
    children: [
      {
        name: "Building Permit",
        id: 24094,
        children: [
          { name: "Application Submitted", id: 24096 },
          { name: "Issued Date", id: 24095 },
        ],
      },
    ],
  },
  {
    name: "Sicamous",
    id: 24087,
    children: [
      { name: "Building Permit (GS)", id: 24088, children: [{ name: "Issued Date", id: 24089 }] },
    ],
  },
  {
    name: "Sechelt",
    id: 24084,
    children: [{ name: "Building Permit", id: 24085, children: [{ name: "Issued", id: 24086 }] }],
  },
  {
    name: "West Kelowna",
    id: 23911,
    children: [
      { name: "Development Permit", id: 23933, children: [{ name: "Issued", id: 23934 }] },
      { name: "Building Permit", id: 23925, children: [{ name: "Issued", id: 23926 }] },
      { name: "Building Permit (GS)", id: 23912, children: [{ name: "Issued", id: 23913 }] },
    ],
  },
  {
    name: "Salmon Arm",
    id: 23917,
    children: [
      { name: "Development Permit", id: 23937, children: [{ name: "Issued", id: 23938 }] },
      { name: "Building Permit (GS)", id: 23918, children: [{ name: "Issued", id: 23919 }] },
    ],
  },
  {
    name: "Penticton",
    id: 23914,
    children: [
      { name: "Development Permit", id: 23935, children: [{ name: "Issued", id: 23936 }] },
      { name: "Building Permit", id: 23927, children: [{ name: "Issued", id: 23928 }] },
      { name: "Building Permit (GS)", id: 23915, children: [{ name: "Issued", id: 23916 }] },
    ],
  },
  {
    name: "Lake Country",
    id: 23920,
    children: [
      { name: "Development Permit", id: 23939, children: [{ name: "Issued", id: 23940 }] },
      { name: "Building Permit (GS)", id: 23921, children: [{ name: "Issued", id: 23922 }] },
      { name: "Building Permit", id: 23929, children: [{ name: "Issued", id: 23930 }] },
    ],
  },
  {
    name: "Vernon",
    id: 23908,
    children: [
      { name: "Development Permit", id: 23931, children: [{ name: "Issued", id: 23932 }] },
      { name: "Building Permit", id: 23923, children: [{ name: "Issued", id: 23924 }] },
      { name: "Building Permit (GS)", id: 23909, children: [{ name: "Issued", id: 23910 }] },
    ],
  },
  {
    name: "Ladysmith",
    id: 23873,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23882,
        children: [
          { name: "Application Submitted", id: 23883 },
          { name: "Approved", id: 23884 },
          { name: "Adopted", id: 23885 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23874,
        children: [
          { name: "Approved", id: 23876 },
          { name: "Issued", id: 23877 },
          { name: "Application Submitted", id: 23875 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23878,
        children: [
          { name: "Issued", id: 23881 },
          { name: "Application Submitted", id: 23879 },
          { name: "Approved", id: 23880 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23886,
        children: [
          { name: "Issued", id: 23888 },
          { name: "Application Submitted", id: 23887 },
        ],
      },
    ],
  },
  {
    name: "Powell River",
    id: 23857,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23866,
        children: [
          { name: "Application Submitted", id: 23867 },
          { name: "Approved", id: 23868 },
          { name: "Adopted", id: 23869 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23858,
        children: [
          { name: "Application Submitted", id: 23859 },
          { name: "Approved", id: 23860 },
          { name: "Issued", id: 23861 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23862,
        children: [
          { name: "Application Submitted", id: 23863 },
          { name: "Approved", id: 23864 },
          { name: "Issued", id: 23865 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23870,
        children: [
          { name: "Application Submitted", id: 23871 },
          { name: "Issued", id: 23872 },
        ],
      },
    ],
  },
  {
    name: "Oak Bay",
    id: 23841,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23850,
        children: [
          { name: "Application Submitted", id: 23851 },
          { name: "Approved", id: 23852 },
          { name: "Adopted", id: 23853 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23842,
        children: [
          { name: "Application Submitted", id: 23843 },
          { name: "Approved", id: 23844 },
          { name: "Issued", id: 23845 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23846,
        children: [
          { name: "Application Submitted", id: 23847 },
          { name: "Approved", id: 23848 },
          { name: "Issued", id: 23849 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23854,
        children: [
          { name: "Issued", id: 23856 },
          { name: "Application Submitted", id: 23855 },
        ],
      },
    ],
  },
  {
    name: "Comox",
    id: 23825,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23834,
        children: [
          { name: "Application Submitted", id: 23835 },
          { name: "Approved", id: 23836 },
          { name: "Adopted", id: 23837 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23826,
        children: [
          { name: "Issued", id: 23829 },
          { name: "Approved", id: 23828 },
          { name: "Application Submitted", id: 23827 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23830,
        children: [
          { name: "Issued", id: 23833 },
          { name: "Approved", id: 23832 },
          { name: "Application Submitted", id: 23831 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23838,
        children: [
          { name: "Issued", id: 23840 },
          { name: "Application Submitted", id: 23839 },
        ],
      },
    ],
  },
  {
    name: "Sidney",
    id: 23809,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23818,
        children: [
          { name: "Application Submitted", id: 23819 },
          { name: "Approved", id: 23820 },
          { name: "Adopted", id: 23821 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23810,
        children: [
          { name: "Issued", id: 23813 },
          { name: "Approved", id: 23812 },
          { name: "Application Submitted", id: 23811 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23814,
        children: [
          { name: "Application Submitted", id: 23815 },
          { name: "Approved", id: 23816 },
          { name: "Issued", id: 23817 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23822,
        children: [
          { name: "Issued", id: 23824 },
          { name: "Application Submitted", id: 23823 },
        ],
      },
    ],
  },
  {
    name: "Campbell River",
    id: 23793,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23802,
        children: [
          { name: "Application Submitted", id: 23803 },
          { name: "Approved", id: 23804 },
          { name: "Adopted", id: 23805 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23794,
        children: [
          { name: "Application Submitted", id: 23795 },
          { name: "Approved", id: 23796 },
          { name: "Issued", id: 23797 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23798,
        children: [
          { name: "Issued", id: 23801 },
          { name: "Approved", id: 23800 },
          { name: "Application Submitted", id: 23799 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23806,
        children: [
          { name: "Application Submitted", id: 23807 },
          { name: "Issued", id: 23808 },
        ],
      },
    ],
  },
  {
    name: "Nanaimo RD",
    id: 23760,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23769,
        children: [
          { name: "Application Submitted", id: 23770 },
          { name: "Approved", id: 23771 },
          { name: "Adopted", id: 23772 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23761,
        children: [
          { name: "Application Submitted", id: 23762 },
          { name: "Approved", id: 23763 },
          { name: "Issued", id: 23764 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23765,
        children: [
          { name: "Application Submitted", id: 23766 },
          { name: "Approved", id: 23767 },
          { name: "Issued", id: 23768 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23773,
        children: [
          { name: "Application Submitted", id: 23774 },
          { name: "Issued", id: 23775 },
        ],
      },
    ],
  },
  {
    name: "View Royal",
    id: 23744,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23753,
        children: [
          { name: "Application Submitted", id: 23754 },
          { name: "Approved", id: 23755 },
          { name: "Adopted", id: 23756 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23745,
        children: [
          { name: "Approved", id: 23747 },
          { name: "Issued", id: 23748 },
          { name: "Application Submitted", id: 23746 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23749,
        children: [
          { name: "Application Submitted", id: 23750 },
          { name: "Approved", id: 23751 },
          { name: "Issued", id: 23752 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23757,
        children: [
          { name: "Application Submitted", id: 23758 },
          { name: "Issued", id: 23759 },
        ],
      },
    ],
  },
  {
    name: "Duncan",
    id: 23728,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23737,
        children: [
          { name: "Application Submitted", id: 23738 },
          { name: "Approved", id: 23739 },
          { name: "Adopted", id: 23740 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23729,
        children: [
          { name: "Application Submitted", id: 23730 },
          { name: "Approved", id: 23731 },
          { name: "Issued", id: 23732 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23733,
        children: [
          { name: "Approved", id: 23735 },
          { name: "Application Submitted", id: 23734 },
          { name: "Issued", id: 23736 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23741,
        children: [
          { name: "Issued", id: 23743 },
          { name: "Application Submitted", id: 23742 },
        ],
      },
    ],
  },
  {
    name: "Port Alberni",
    id: 23712,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23721,
        children: [
          { name: "Application Submitted", id: 23722 },
          { name: "Approved", id: 23723 },
          { name: "Adopted", id: 23724 },
        ],
      },
      {
        name: "OCP Amendment (YS)",
        id: 23889,
        children: [
          { name: "Application Submitted", id: 23890 },
          { name: "Approved", id: 23891 },
          { name: "Adopted", id: 23892 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23713,
        children: [
          { name: "Application Submitted", id: 23714 },
          { name: "Approved", id: 23715 },
          { name: "Issued", id: 23716 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23717,
        children: [
          { name: "Application Submitted", id: 23718 },
          { name: "Approved", id: 23719 },
          { name: "Issued", id: 23720 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23725,
        children: [
          { name: "Application Submitted", id: 23726 },
          { name: "Issued", id: 23727 },
        ],
      },
    ],
  },
  {
    name: "Saanich (Central)",
    id: 23696,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23705,
        children: [
          { name: "Application Submitted", id: 23706 },
          { name: "Approved", id: 23707 },
          { name: "Adopted", id: 23708 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23697,
        children: [
          { name: "Application Submitted", id: 23698 },
          { name: "Approved", id: 23699 },
          { name: "Issued", id: 23700 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23701,
        children: [
          { name: "Approved", id: 23703 },
          { name: "Application Submitted", id: 23702 },
          { name: "Issued", id: 23704 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23709,
        children: [
          { name: "Application Submitted", id: 23710 },
          { name: "Issued", id: 23711 },
        ],
      },
    ],
  },
  {
    name: "North Cowichan",
    id: 23680,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23689,
        children: [
          { name: "Application Submitted", id: 23690 },
          { name: "Approved", id: 23691 },
          { name: "Adopted", id: 23692 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23681,
        children: [
          { name: "Issued", id: 23684 },
          { name: "Application Submitted", id: 23682 },
          { name: "Approved", id: 23683 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23685,
        children: [
          { name: "Application Submitted", id: 23686 },
          { name: "Approved", id: 23687 },
          { name: "Issued", id: 23688 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23693,
        children: [
          { name: "Application Submitted", id: 23694 },
          { name: "Issued", id: 23695 },
        ],
      },
    ],
  },
  {
    name: "Courtenay",
    id: 23664,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23673,
        children: [
          { name: "Application Submitted", id: 23674 },
          { name: "Approved", id: 23675 },
          { name: "Adopted", id: 23676 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23665,
        children: [
          { name: "Application Submitted", id: 23666 },
          { name: "Approved", id: 23667 },
          { name: "Issued", id: 23668 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23669,
        children: [
          { name: "Application Submitted", id: 23670 },
          { name: "Approved", id: 23671 },
          { name: "Issued", id: 23672 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23677,
        children: [
          { name: "Application Submitted", id: 23678 },
          { name: "Issued", id: 23679 },
        ],
      },
    ],
  },
  { name: "Seattle", id: 23576, children: [] },
  { name: "Miami", id: 23575, children: [] },
  {
    name: "Calgary",
    id: 23531,
    children: [
      {
        name: "Building Permit",
        id: 23532,
        children: [
          { name: "Application Submitted", id: 23574 },
          { name: "Issued", id: 23533 },
        ],
      },
    ],
  },
  {
    name: "Canmore",
    id: 23540,
    children: [{ name: "Building Permit", id: 23541, children: [{ name: "Issued", id: 23542 }] }],
  },
  {
    name: "Edmonton",
    id: 23534,
    children: [{ name: "Building Permit", id: 23535, children: [{ name: "Issued", id: 23536 }] }],
  },
  {
    name: "Esquimalt",
    id: 23328,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23604,
        children: [
          { name: "Application Submitted", id: 23605 },
          { name: "Approved", id: 23606 },
          { name: "Adopted", id: 23607 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23596,
        children: [
          { name: "Application Submitted", id: 23597 },
          { name: "Approved", id: 23598 },
          { name: "Issued", id: 23599 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23600,
        children: [
          { name: "Issued", id: 23603 },
          { name: "Approved", id: 23602 },
          { name: "Application Submitted", id: 23601 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23608,
        children: [
          { name: "Application Submitted", id: 23609 },
          { name: "Issued", id: 23610 },
        ],
      },
      {
        name: "Rezoning Permit",
        id: 23329,
        children: [{ name: "Application Date", id: 23330 }],
      },
      {
        name: "Development Permit",
        id: 23331,
        children: [{ name: "Application Date", id: 23332 }],
      },
      {
        name: "Rezoning + Development Permit",
        id: 23333,
        children: [
          {
            name: "Council Meeting",
            id: 23435,
            children: [
              { name: "Application Date", id: 23334 },
              {
                name: "Adopted & Issued",
                id: 23433,
                children: [{ name: "Carried", id: 23434 }],
              },
            ],
          },
        ],
      },
      {
        name: "Development + Development Variance Permit",
        id: 23335,
        children: [
          { name: "Application Date", id: 23336 },
          { name: "Issued", id: 23337, children: [{ name: "Carried", id: 23338 }] },
        ],
      },
      {
        name: "Building Permit",
        id: 23431,
        children: [{ name: "Issued Date", id: 23432 }],
      },
    ],
  },
  {
    name: "Saanich",
    id: 23318,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23634,
        children: [
          { name: "Application Submitted", id: 23635 },
          { name: "Approved", id: 23636 },
          { name: "Adopted", id: 23637 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23626,
        children: [
          { name: "Application Submitted", id: 23627 },
          { name: "Approved", id: 23628 },
          { name: "Issued", id: 23629 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23630,
        children: [
          { name: "Application Submitted", id: 23631 },
          { name: "Approved", id: 23632 },
          { name: "Issued", id: 23633 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23638,
        children: [
          { name: "Application Submitted", id: 23639 },
          { name: "Issued", id: 23640 },
        ],
      },
      {
        name: "Rezoning Permit",
        id: 23319,
        children: [
          { name: "Application Date", id: 23320 },
          {
            name: "Council Meeting",
            id: 23341,
            children: [
              { name: "1st Reading", id: 23342, children: [{ name: "Carried", id: 23343 }] },
              { name: "2nd Reading", id: 23344, children: [{ name: "Carried", id: 23345 }] },
              { name: "1st & 2nd Reading", id: 23346, children: [{ name: "Carried", id: 23347 }] },
              { name: "2nd & 3d Reading", id: 23350, children: [{ name: "Carried", id: 23351 }] },
              { name: "Public Hearing", id: 23352 },
              { name: "3rd Reading", id: 23348, children: [{ name: "Carried", id: 23349 }] },
              { name: "Final Adoption", id: 23353, children: [{ name: "Carried", id: 23354 }] },
            ],
          },
        ],
      },
      {
        name: "Development Permit",
        id: 23321,
        children: [
          { name: "Application Date", id: 23322 },
          {
            name: "Council Meeting",
            id: 23355,
            children: [
              {
                name: "Authorized to Issue",
                id: 23356,
                children: [{ name: "Carried", id: 23357 }],
              },
            ],
          },
        ],
      },
      {
        name: "Rezoning + Development Permit",
        id: 23325,
        children: [
          { name: "Application Date", id: 23326 },
          {
            name: "Council Meeting",
            id: 23340,
            children: [
              { name: "1st Reading", id: 23358, children: [{ name: "Carried", id: 23359 }] },
              { name: "2nd Reading", id: 23360, children: [{ name: "Carried", id: 23361 }] },
              { name: "1st & 2nd Reading", id: 23362, children: [{ name: "Carried", id: 23363 }] },
              { name: "Public Hearing", id: 23339 },
              { name: "2nd & 3rd Reading", id: 23366, children: [{ name: "Carried", id: 23367 }] },
              { name: "3rd Reading", id: 23364, children: [{ name: "Carried", id: 23365 }] },
              {
                name: "Final Adoption & Authorized to Issue",
                id: 23368,
                children: [{ name: "Carried", id: 23369 }],
              },
            ],
          },
        ],
      },
      {
        name: "Building Permit",
        id: 23323,
        children: [{ name: "Issued", id: 23324 }],
      },
    ],
  },
  {
    name: "Sooke",
    id: 22817,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23784,
        children: [
          { name: "Application Submitted", id: 23785 },
          { name: "Approved", id: 23786 },
          { name: "Adopted", id: 23787 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23776,
        children: [
          { name: "Approved", id: 23778 },
          { name: "Issued", id: 23779 },
          { name: "Application Submitted", id: 23777 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23780,
        children: [
          { name: "Issued", id: 23783 },
          { name: "Approved", id: 23782 },
          { name: "Application Submitted", id: 23781 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23788,
        children: [
          { name: "Issued", id: 23790 },
          { name: "Application Submitted", id: 23789 },
        ],
      },
      {
        name: "Rezoning Permit",
        id: 22818,
        children: [
          { name: "Application Date", id: 22819 },
          {
            name: "Regular Council Meeting",
            id: 22820,
            children: [
              { name: "1st Reading", id: 22821, children: [{ name: "Carried", id: 22822 }] },
              { name: "2nd Reading", id: 22823, children: [{ name: "Carried", id: 22824 }] },
              {
                name: "1st & 2nd Reading",
                id: 22825,
                children: [
                  { name: "3rd Reading", id: 22829, children: [{ name: "Carried", id: 22830 }] },
                  { name: "Carried", id: 22826 },
                ],
              },
              { name: "2nd & 3rd Reading", id: 22827, children: [{ name: "Carried", id: 22828 }] },
              { name: "Public Hearing", id: 22831 },
              { name: "Final Adoption", id: 22832, children: [{ name: "Carried", id: 22833 }] },
            ],
          },
        ],
      },
      {
        name: "Development Permit",
        id: 22834,
        children: [
          {
            name: "Regular Council Meeting",
            id: 22836,
            children: [
              {
                name: "Authorized for Issuance",
                id: 22837,
                children: [{ name: "Carried", id: 22838 }],
              },
            ],
          },
          { name: "Application Date", id: 22835 },
        ],
      },
      {
        name: "Rezoning + Development Permit",
        id: 22839,
        children: [
          {
            name: "Regular Council Meeting",
            id: 22841,
            children: [
              { name: "1st Reading", id: 22842, children: [{ name: "Carried", id: 22843 }] },
              { name: "2nd Reading", id: 22844, children: [{ name: "Carried", id: 22845 }] },
              { name: "1st & 2nd Reading", id: 22846, children: [{ name: "Carried", id: 22847 }] },
              { name: "3rd Reading", id: 22850, children: [{ name: "Carried", id: 22851 }] },
              { name: "2nd & 3rd Reading", id: 22848, children: [{ name: "Carried", id: 22849 }] },
              { name: "Public Hearing", id: 22852 },
              {
                name: "Final Adoption & Authorized for Issuance",
                id: 22853,
                children: [{ name: "Carried", id: 22854 }],
              },
            ],
          },
          { name: "Application Date", id: 22840 },
        ],
      },
    ],
  },
  {
    name: "Nanaimo",
    id: 22644,
    children: [
      {
        name: "Rezoning Permit (YS)",
        id: 23567,
        children: [
          { name: "Application Submitted", id: 23568 },
          { name: "Approved", id: 23569 },
          { name: "Adopted", id: 23570 },
        ],
      },
      {
        name: "Development Permit (YS)",
        id: 23558,
        children: [
          { name: "Application Submitted", id: 23560 },
          { name: "Approved", id: 23561 },
          { name: "Issued", id: 23562 },
        ],
      },
      {
        name: "Development Permit with Variance (YS)",
        id: 23563,
        children: [
          { name: "Application Submitted", id: 23564 },
          { name: "Approved", id: 23565 },
          { name: "Issued", id: 23566 },
        ],
      },
      {
        name: "Building Permit (YS)",
        id: 23571,
        children: [
          { name: "Application Submitted", id: 23572 },
          { name: "Issued", id: 23573 },
        ],
      },
      {
        name: "Building Permit",
        id: 22682,
        children: [
          {
            name: "Commercial / Multi / Industrial",
            id: 22683,
            children: [
              { name: "Application Submitted", id: 22684 },
              { name: "Issued Date", id: 22685 },
            ],
          },
        ],
      },
      {
        name: "Development Permit",
        id: 22661,
        children: [
          { name: "Design Advisory Panel", id: 23104 },
          { name: "Application Date", id: 22662 },
          {
            name: "Council Meeting",
            id: 22663,
            children: [
              {
                name: "Authorized to Issue",
                id: 22664,
                children: [{ name: "Carried", id: 22665 }],
              },
            ],
          },
        ],
      },
      {
        name: "Rezoning + Development Permit",
        id: 22666,
        children: [
          { name: "Application Date", id: 22667 },
          { name: "Public Hearing", id: 22668 },
          {
            name: "Council Meeting",
            id: 22669,
            children: [
              { name: "1st Reading", id: 22670, children: [{ name: "Carried", id: 22671 }] },
              { name: "2nd Reading", id: 22672, children: [{ name: "Carried", id: 22673 }] },
              { name: "1st & 2nd Reading", id: 22674, children: [{ name: "Carried", id: 22675 }] },
              { name: "2nd & 3rd Reading", id: 22676, children: [{ name: "Carried", id: 22677 }] },
              { name: "3rd Reading", id: 22678, children: [{ name: "Carried", id: 22679 }] },
              {
                name: "Final Adoption & Authorized to Issue",
                id: 22680,
                children: [{ name: "Carried", id: 22681 }],
              },
            ],
          },
        ],
      },
      {
        name: "Rezoning",
        id: 22645,
        children: [
          { name: "Application Date", id: 22646 },
          { name: "Public Hearing", id: 22647 },
          {
            name: "Council Meeting",
            id: 22648,
            children: [
              { name: "1st Reading", id: 22649, children: [{ name: "Carried", id: 22650 }] },
              { name: "2nd Reading", id: 22651, children: [{ name: "Carried", id: 22652 }] },
              { name: "1st & 2nd Reading", id: 22653, children: [{ name: "Carried", id: 22654 }] },
              { name: "2nd & 3rd Reading", id: 22655, children: [{ name: "Carried", id: 22656 }] },
              { name: "3rd Reading", id: 22657, children: [{ name: "Carried", id: 22658 }] },
              { name: "Final Adoption", id: 22659, children: [{ name: "Carried", id: 22660 }] },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Township of Langley",
    id: 10855,
    children: [
      {
        name: "Rezoning & Development Permit & Development Variance Permit",
        id: 13696,
        children: [
          { name: "Application Date", id: 13697 },
          {
            name: "Public Information Meeting",
            id: 13698,
            children: [
              { name: "Building Permit (GS)", id: 21566 },
              { name: "Issued Date", id: 21448 },
            ],
          },
          { name: "Public Hearing", id: 13699 },
          { name: "Regular Council Meeting", id: 13700 },
        ],
      },
      {
        name: "Rezoning Application",
        id: 3813,
        children: [
          { name: "Application Date", id: 3818 },
          { name: "Public Information Meeting", id: 11710 },
          { name: "Public Hearing", id: 3833 },
          {
            name: "Regular Council Meeting",
            id: 10856,
            children: [
              {
                name: "First and Second Reading & Authorized to Schedule Public Hearing",
                id: 13505,
                children: [
                  { name: "Carried", id: 13512 },
                  { name: "Defeated", id: 13508 },
                  { name: "Tabled", id: 13509, children: [{ name: "Carried", id: 13507 }] },
                  {
                    name: "Referred Back to Staff",
                    id: 13511,
                    children: [{ name: "Carried", id: 13510 }],
                  },
                ],
              },
              {
                name: "First and Second Reading",
                id: 13429,
                children: [
                  { name: "Carried", id: 11714 },
                  { name: "Defeated", id: 13419 },
                  { name: "Tabled", id: 13439, children: [{ name: "Carried", id: 13441 }] },
                  {
                    name: "Referred Back to Staff",
                    id: 13444,
                    children: [{ name: "Carried", id: 13446 }],
                  },
                ],
              },
              {
                name: "Third Reading",
                id: 13430,
                children: [
                  { name: "Carried", id: 13431 },
                  { name: "Defeated", id: 13432 },
                  { name: "Tabled", id: 13440, children: [{ name: "Carried", id: 13442 }] },
                  {
                    name: "Referred Back to Staff",
                    id: 13443,
                    children: [{ name: "Carried", id: 13445 }],
                  },
                ],
              },
              {
                name: "Public Hearing & 3rd Reading",
                id: 13683,
                children: [
                  { name: "Carried", id: 13684 },
                  { name: "Defeated", id: 13685 },
                ],
              },
              {
                name: "Third Reading & Final Reading",
                id: 13436,
                children: [
                  { name: "Carried", id: 13434 },
                  { name: "Defeated", id: 13435 },
                  { name: "Tabled", id: 13449, children: [{ name: "Carried", id: 13447 }] },
                  {
                    name: "Referred Back to Staff",
                    id: 13448,
                    children: [{ name: "Carried", id: 13450 }],
                  },
                ],
              },
              {
                name: "Final Reading",
                id: 13433,
                children: [
                  { name: "Carried", id: 13437 },
                  { name: "Defeated", id: 13438 },
                  { name: "Tabled", id: 13426, children: [{ name: "Carried", id: 13427 }] },
                  {
                    name: "Referred Back to Staff",
                    id: 13390,
                    children: [{ name: "Carried", id: 13391 }],
                  },
                ],
              },
              {
                name: "Second Reading Rescinded",
                id: 13420,
                children: [
                  { name: "Carried", id: 13424 },
                  { name: "Defeated", id: 13425 },
                ],
              },
              {
                name: "Second Reading",
                id: 13423,
                children: [
                  { name: "Carried", id: 13421 },
                  { name: "Defeated", id: 13422 },
                ],
              },
            ],
          },
        ],
      },
      {
        name: "Building Permit (New)",
        id: 16296,
        children: [
          { name: "Commercial", id: 21081, children: [{ name: "Issued Date", id: 21082 }] },
          { name: "Multi-Family", id: 21083, children: [{ name: "Issued Date", id: 21084 }] },
          { name: "Plumbing", id: 21087, children: [{ name: "Issued Date", id: 21086 }] },
          { name: "Residential", id: 21085, children: [{ name: "Issued Date", id: 21088 }] },
          { name: "Demolition", id: 16297, children: [{ name: "Issued", id: 16298 }] },
          { name: "Site Services", id: 16299, children: [{ name: "Issued", id: 16300 }] },
          { name: "Excavation", id: 16301, children: [{ name: "Issued", id: 16302 }] },
          { name: "Site Shoring", id: 16303, children: [{ name: "Issued", id: 16304 }] },
          { name: "Foundation", id: 16305, children: [{ name: "Issued", id: 16306 }] },
          { name: "Structural", id: 16307, children: [{ name: "Issued", id: 16308 }] },
          { name: "Full", id: 16309, children: [{ name: "Issued", id: 16310 }] },
        ],
      },
      {
        name: "Building Permit (GS)",
        id: 21356,
        children: [
          { name: "Commercial New", id: 21357, children: [{ name: "Issued Date", id: 21358 }] },
          { name: "Foundations", id: 21359, children: [{ name: "Issued Date", id: 21360 }] },
          { name: "Mixed-Use Dev", id: 21361, children: [{ name: "Issued Date", id: 21362 }] },
          { name: "Multi-Family New", id: 21363, children: [{ name: "Issued Date", id: 21364 }] },
          {
            name: "Demolition/Deconstruction",
            id: 21365,
            children: [{ name: "Issued Date", id: 21366 }],
          },
        ],
      },
      {
        name: "Subdivision",
        id: 3836,
        children: [
          { name: "Application Date", id: 3837 },
          { name: "Preliminary Layout Approval (PLA)", id: 11713 },
          { name: "Final Approval", id: 13057 },
        ],
      },
    ],
  },
];

// tid -> { node, parents: [ancestor tids, root first] }. Built once so a stored
// leaf can be turned back into the cascade of selects that reaches it.
const INDEX = (() => {
  const index = new Map();
  const walk = (nodes, parents) => {
    nodes.forEach((node) => {
      index.set(Number(node.id), { node, parents });
      if (node.children && node.children.length) {
        walk(node.children, [...parents, Number(node.id)]);
      }
    });
  };
  walk(CITY_APPLICATION_STAGES, []);
  return index;
})();

// The options at one level, in the shape the cascade renders: `has_children`
// marks a term that is a branch, and so not a value on its own.
const toOptions = (nodes) =>
  (nodes || []).map((node) => ({
    tid: Number(node.id),
    name: node.name,
    has_children: Boolean(node.children && node.children.length),
  }));

// The children of `parentTid` — pass nothing (or 0) for the city level.
export function stageLevelOptions(parentTid) {
  if (!parentTid) return toOptions(CITY_APPLICATION_STAGES);
  const entry = INDEX.get(Number(parentTid));
  return entry ? toOptions(entry.node.children) : [];
}

// "City / Permit Type / Stage" for a term, root first.
export function stageBreadcrumb(tid) {
  const entry = INDEX.get(Number(tid));
  if (!entry) return "";
  const names = entry.parents.map((parent) => INDEX.get(parent).node.name);
  names.push(entry.node.name);
  return names.join(" / ");
}

// The cascade that reaches a stored term: one { options, selected } per level,
// city first. Null when the term is not in this tree — a value stored before
// the vocabulary was pinned here, which the caller has to handle rather than
// silently drop.
export function stageLevelsFor(tid) {
  const entry = INDEX.get(Number(tid));
  if (!entry) return null;
  const chain = [...entry.parents, Number(tid)];
  return chain.map((selected, depth) => ({
    options: stageLevelOptions(depth === 0 ? 0 : chain[depth - 1]),
    selected,
  }));
}

// True when the term is a leaf, i.e. a valid value for the field.
export function isStageLeaf(tid) {
  const entry = INDEX.get(Number(tid));
  return Boolean(entry && !(entry.node.children && entry.node.children.length));
}
